import {useForm} from 'react-hook-form';
import {TextFieldElement} from 'react-hook-form-mui';
import {yupResolver} from '@hookform/resolvers/yup';
import {Button, Dialog, DialogActions, DialogContent} from '@mui/material';
import {object, string} from 'yup';

import {useBanUser} from '@entities/user';
import {DialogTitle} from '@shared/components';

const schema = object().shape({
  comment: string().trim().required().max(1000),
});

interface Props {
  userId: string;
  username: string;
  onClose: () => void;
}

export const BanUserDialog = ({userId, username, onClose}: Props) => {
  const {mutate: banUser, isPending} = useBanUser();
  const {control, handleSubmit} = useForm({
    resolver: yupResolver(schema),
    defaultValues: {comment: ''},
  });
  const handleClose = () => {
    if (!isPending) onClose();
  };

  return (
    <Dialog
      open
      onClose={handleClose}
      fullWidth
      maxWidth={false}
      sx={{'& .MuiDialog-paper': {maxWidth: 600}}}
    >
      <form
        noValidate
        onSubmit={handleSubmit(({comment}) => {
          if (!isPending) banUser({userId, comment}, {onSuccess: onClose});
        })}
      >
        <DialogTitle title={`Ban @${username}`} onClose={handleClose} />
        <DialogContent sx={{pt: '20px !important'}}>
          <TextFieldElement
            name="comment"
            label="Comment"
            control={control}
            required
            multiline
            minRows={3}
            fullWidth
            disabled={isPending}
            inputProps={{maxLength: 1000}}
          />
        </DialogContent>
        <DialogActions>
          <Button variant="outlined" onClick={handleClose} disabled={isPending}>
            Cancel
          </Button>
          <Button type="submit" color="error" disabled={isPending}>
            Ban user
          </Button>
        </DialogActions>
      </form>
    </Dialog>
  );
};
